import React from "react";
import { ArrowUpRight, Calendar } from "lucide-react";

export default function CTABanner() {
  return (
    <section
      data-testid="cta-banner-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8">
        <div className="mk-reveal relative overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-br from-[#0A1628] via-[#091B33] to-[#07111F] p-10 md:p-20">
          <div className="absolute inset-0 mk-grid-bg opacity-50" aria-hidden />
          <div
            className="mk-orb"
            style={{ width: 320, height: 320, background: "#0A66FF", top: -60, left: -60, opacity: 0.4 }}
            aria-hidden
          />
          <div
            className="mk-orb"
            style={{ width: 280, height: 280, background: "#00D4FF", bottom: -80, right: -40, opacity: 0.25, animationDelay: "2s" }}
            aria-hidden
          />

          <div className="relative max-w-3xl">
            <span className="inline-flex items-center rounded-full border border-white/15 bg-white/[0.04] px-3 py-1 text-[11px] uppercase tracking-[0.22em] text-[#00D4FF]">
              Let's build
            </span>
            <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl tracking-tight text-white leading-[1.05]">
              Have a project in mind?
            </h2>
            <p className="mt-6 text-lg text-slate-300 max-w-2xl leading-relaxed">
              Whether you need a high-quality website, a custom application or a
              new product concept, we can help you define it, design it and build
              it properly.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <a
                href="#contact"
                data-testid="cta-banner-start-button"
                className="inline-flex items-center justify-center gap-2 mk-btn-primary px-7 py-4 rounded-full text-[15px] font-semibold"
              >
                Start a Project <ArrowUpRight className="h-4 w-4" />
              </a>
              <a
                href="#book-call"
                data-testid="cta-banner-consultation-button"
                className="inline-flex items-center justify-center gap-2 mk-btn-secondary px-7 py-4 rounded-full text-[15px] font-semibold"
              >
                <Calendar className="h-4 w-4" />
                Request a Consultation
              </a>
            </div>

            <p
              className="mt-6 text-[13px] text-slate-500 max-w-xl"
              data-testid="cta-banner-micro-line"
            >
              Serious enquiries only — we focus on projects where quality and
              execution matter.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
